import { Hr } from './styles';

const Separator = () => {
	return <Hr />;
};

export { Separator };
